import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import ENDPOINT from '../../../../constants/endpoints';
import {POSITION_FLAG} from '../../../../constants/profile';
import EditEducationForm from './components/EditEducationForm';
import EditPositionForm from './components/EditPositionForm';

const EditCandidatePositionForm = props => {
  const endpoint = useMemo(() => {
    return props.params.isMyProfile
      ? {
          getForm: props.type === POSITION_FLAG.POSITION ? ENDPOINT.FORM.GET.EXPERIENCE : ENDPOINT.FORM.GET.POSITION,
          saveForm: props.type === POSITION_FLAG.POSITION ? ENDPOINT.FORM.SAVE.EXPERIENCE : ENDPOINT.FORM.SAVE.POSITION,
          getFirms: ENDPOINT.FORM.OPTIONS.POSITION.FIRMS,
          getSchools: ENDPOINT.FORM.OPTIONS.POSITION.SCHOOLS,
          getLocations: ENDPOINT.FORM.OPTIONS.POSITION.LOCATIONS,
        }
      : {
          getFirms: ENDPOINT.FORM.OPTIONS.EDIT_POSITION.FIRMS,
          getSchools: ENDPOINT.FORM.OPTIONS.POSITION.SCHOOLS,
          getLocations: ENDPOINT.FORM.OPTIONS.POSITION.LOCATIONS,
          ...(props.params.isMasterAccount
            ? {
                getForm: props.type === POSITION_FLAG.POSITION ? ENDPOINT.FORM.GET.SU_EDIT_CANDIDATE_PROFILE_EXPERIENCE : ENDPOINT.FORM.GET.SU_EDIT_CANDIDATE_PROFILE_POSITION,
                saveForm: props.type === POSITION_FLAG.POSITION ? ENDPOINT.FORM.SAVE.SU_EDIT_CANDIDATE_PROFILE_EXPERIENCE : ENDPOINT.FORM.SAVE.SU_EDIT_CANDIDATE_PROFILE_POSITION,
              }
            : {
                getForm: ENDPOINT.FORM.GET.EDIT_CANDIDATE_PROFILE_POSITION,
                saveForm: ENDPOINT.FORM.SAVE.EDIT_CANDIDATE_PROFILE_POSITION,
              }),
        };
  }, [props.params, props.type]);

  return props.type === POSITION_FLAG.POSITION ? (
    <EditPositionForm {...props} endpoint={endpoint} />
  ) : (
    <EditEducationForm {...props} endpoint={endpoint} />
  );
};

EditCandidatePositionForm.propTypes = {
  params: PropTypes.object,
  actions: PropTypes.shape({
    handleError: PropTypes.func,
    proceed: PropTypes.func,
    dismiss: PropTypes.func,
  }),
  type: PropTypes.oneOf([POSITION_FLAG.POSITION, POSITION_FLAG.EDUCATION]),
};

export default EditCandidatePositionForm;
